import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../base/LanguageSwitcher';
import { useState } from 'react';

export default function Navigation() {
  const { t } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="fixed top-0 left-0 right-0 bg-blue-950/80 backdrop-blur-md z-50">
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <div
            onClick={() => scrollToSection('hero')}
            className="flex items-baseline text-white font-bold cursor-pointer hover:text-blue-300 transition-colors whitespace-nowrap"
            style={{ fontFamily: '"Freestyle Script", "Pacifico", cursive' }}
            lang="en"
          >
            <span className="text-4xl md:text-6xl">J</span>
            <span className="-ml-2 md:-ml-3 text-xl md:text-3xl">SPM</span>
            <span className="ml-1 md:ml-2 text-base md:text-3xl font-normal">Engineering Co., Ltd.</span>
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer whitespace-nowrap leading-none"
            >
              {t('nav.home')}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer whitespace-nowrap leading-none"
            >
              {t('nav.about')}
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer whitespace-nowrap leading-none"
            >
              {t('nav.portfolio')}
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer whitespace-nowrap leading-none"
            >
              {t('nav.partners')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer whitespace-nowrap leading-none"
            >
              {t('nav.contact')}
            </button>
            <LanguageSwitcher className="self-center flex-shrink-0" />
          </div>

          <button
            className="md:hidden text-white focus:outline-none"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i
              className={`ri-${isMenuOpen ? 'close-line' : 'menu-line'} w-6 h-6 flex items-center justify-center text-xl`}
            ></i>
          </button>
        </div>

        {isMenuOpen && (
          <div className="md:hidden flex flex-col space-y-2 pb-4">
            <button
              onClick={() => scrollToSection('hero')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer text-left leading-none"
            >
              {t('nav.home')}
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer text-left leading-none"
            >
              {t('nav.about')}
            </button>
            <button
              onClick={() => scrollToSection('portfolio')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer text-left leading-none"
            >
              {t('nav.portfolio')}
            </button>
            <button
              onClick={() => scrollToSection('partners')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer text-left leading-none"
            >
              {t('nav.partners')}
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-white hover:text-blue-300 transition-colors cursor-pointer text-left leading-none"
            >
              {t('nav.contact')}
            </button>
            <LanguageSwitcher className="self-start" />
          </div>
        )}
      </div>
    </nav>
  );
}

